module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-8-1c91a0d04b8f37f6475ff5ab7613b532.svg";